import React from 'react';
import { TOOLBARS, useEditorToolbar } from '@atlaskit/editor-common/toolbar';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import { ToolbarSection } from '@atlaskit/editor-toolbar';
var shouldShowSection = function shouldShowSection(editMode, toolbar, toolbarDocking, disableSelectionToolbar) {
  if (editMode === 'view') {
    return false;
  }
  if (disableSelectionToolbar) {
    return true;
  }
  if ((toolbar === null || toolbar === void 0 ? void 0 : toolbar.key) === TOOLBARS.INLINE_TEXT_TOOLBAR && toolbarDocking !== 'top') {
    return true;
  }
  if ((toolbar === null || toolbar === void 0 ? void 0 : toolbar.key) === TOOLBARS.PRIMARY_TOOLBAR && toolbarDocking !== 'none') {
    return true;
  }
  return false;
};
export var Section = function Section(_ref) {
  var children = _ref.children,
    parents = _ref.parents,
    api = _ref.api,
    testId = _ref.testId,
    showSeparatorInFullPagePrimaryToolbar = _ref.showSeparatorInFullPagePrimaryToolbar,
    _ref$isSharedSection = _ref.isSharedSection,
    isSharedSection = _ref$isSharedSection === void 0 ? true : _ref$isSharedSection,
    disableSelectionToolbar = _ref.disableSelectionToolbar;
  var editMode = useSharedPluginStateSelector(api, 'editorViewMode.mode');
  var toolbarDocking = useSharedPluginStateSelector(api, 'userPreferences.preferences.toolbarDockingPosition');
  var toolbar = parents.find(function (parent) {
    return parent.type === 'toolbar';
  });
  var _useEditorToolbar = useEditorToolbar(),
    editorAppearance = _useEditorToolbar.editorAppearance;
  if (isSharedSection && !shouldShowSection(editMode, toolbar, toolbarDocking, disableSelectionToolbar)) {
    return null;
  }
  var isFullPage = editorAppearance === 'full-page';
  return /*#__PURE__*/React.createElement(ToolbarSection, {
    testId: testId,
    hasSeparator: showSeparatorInFullPagePrimaryToolbar && isFullPage
  }, children);
};